import createVueComponent from '../createVueComponent';

const History = createVueComponent('HistoryIcon', [
  ['path', { d: 'M3 3v5h5' }],
  ['path', { d: 'M3.05 13A9 9 0 106 5.3L3 8' }],
  ['path', { d: 'M12 7v5l4 2' }],
]);

export default History;
